<template>
  <form action="" method="post" class="sm:relative">
    <input type="hidden" name="_token" :value="csrf" />

    <div class="flex items-center">
      <button
        type="button"
        class="cursor-pointer text-xl text-gray-500 hover:text-black"
        @click="show = !show"
      >
        <span class="fas fa-cog"></span>
      </button>
    </div>
    <div
      class="absolute left-0 right-0 z-50 mx-4 mt-3 flex flex-col overflow-hidden whitespace-nowrap rounded bg-white pt-3 shadow sm:left-auto sm:mx-0"
      v-if="show"
    >
      <div class="flex flex-col px-5 py-1" v-for="{ name, value, label } in options" :key="name">
        <input type="hidden" :name="name" value="0" />
        <label class="flex items-center">
          <input type="checkbox" :name="name" value="1" :checked="value" class="form-checkbox" />
          <span class="ml-2">
            {{ label }}
          </span>
        </label>
      </div>
      <div class="mt-3 flex justify-end bg-gray-100 p-2 text-sm">
        <button
          class="flex items-baseline rounded bg-brand-500 px-3 py-1 text-white hover:bg-brand-800 hover:text-brand-100"
          ref="submitButton"
        >
          <span class="far fa-check mr-1"></span>
          {{ $t('global.apply') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    csrf: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    show(show) {
      if (show) {
        document.addEventListener('click', this.closeIfClickedOutside)
      } else {
        document.removeEventListener('click', this.closeIfClickedOutside)
      }
    },
  },
  methods: {
    closeIfClickedOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.show = false
      }
    },
  },
}
</script>
